var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input',{attrs:{"type":"search","icon":"search","placeholder":_vm.placeholder},on:{"input":_vm.searchChanged},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})}
var staticRenderFns = []

export { render, staticRenderFns }